import { createFileRoute, redirect } from "@tanstack/react-router";
import { zodValidator } from "@tanstack/zod-adapter";
import { z } from "zod";

import { getSafeCliRedirectUrl } from "@/common/cli-redirect";

const signoutSearchSchema = z.object({
  redirect_url: z.string().optional(),
});

// Residual landing route: the real sign-out runs server-side (POST/GET
// /auth/logout → Tank /logout). Old links, bookmarks, and the retired gateway
// sign-out chain may still hit /signout, so it simply lands the user on the
// (sanitized) redirect target — home by default.
export const Route = createFileRoute("/_rootLayout/signout")({
  validateSearch: zodValidator(signoutSearchSchema),
  ssr: false,
  beforeLoad: ({ search, preload }) => {
    // Preload must not navigate on hover; the real navigation re-runs
    // beforeLoad without preload. Mirrors signin.
    if (preload) return;

    // Sanitize the return target through the SAME allowlist signin/signup use
    // so it can never become an open redirect. With no target, land on home —
    // NOT the allowlist's /account default, which would bounce a just-signed-
    // out visitor straight back into the login flow.
    const redirectUrl = search.redirect_url
      ? getSafeCliRedirectUrl(search.redirect_url)
      : "/";
    throw redirect(
      redirectUrl.startsWith("/") ? { to: redirectUrl } : { href: redirectUrl },
    );
  },
  component: SignOutRoute,
});

// beforeLoad always redirects on a real navigation; this renders only for the
// preload early-return, so keep it inert.
function SignOutRoute() {
  return null;
}
